module.exports = __webpack_public_path__ + "icons/bump-icon-2-7f4ff5dee5bee838b6c45d4af0d4155f.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/bump-icon-2.svg
// module id = wFl3
// module chunks = 19